const GAME_STATUS = {
  NEW: 'new',
  PLAYING: 'playing',
  PAUSED: 'paused',
  STOPPED: 'stopped',
}

export default GAME_STATUS
